import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { CommandPaletteSearchResult } from "components/CommandPalette/types";

import { SEARCH_POLICIES_FOR_NAVIGATION, SearchPoliciesForNavigationItem } from "./gql";

type UsePolicySearchForNavigationProps = {
  query: string;
};

const usePolicySearchForNavigation = ({
  query,
}: UsePolicySearchForNavigationProps): CommandPaletteSearchResult<SearchPoliciesForNavigationItem> => {
  const { data, previousData, loading } = useQuery(SEARCH_POLICIES_FOR_NAVIGATION, {
    variables: {
      input: {
        after: null,
        first: 10,
        fullTextSearch: query,
        predicates: [],
        orderBy: null,
        requestedPage: null,
      },
    },
  });

  const policies = useMemo(() => {
    return (
      data?.searchPolicies?.edges.map((edge) => edge.node) ||
      previousData?.searchPolicies?.edges.map((edge) => edge.node) ||
      []
    );
  }, [data, previousData]);

  return {
    items: policies,
    loading,
    hasMore: !!data?.searchPolicies?.pageInfo.hasNextPage,
    isEmpty: policies.length === 0,
  };
};

export default usePolicySearchForNavigation;
